import { CustomerDto } from '../../service/types'

const stripDiacritics = (s: string): string => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

export const filterCustomers = <T extends CustomerDto>(customers: T[], query: string): T[] => {
  const trimmed = stripDiacritics(query.trim().toLowerCase())
  if (!trimmed) return customers

  return customers.filter((c) => {
    const name = stripDiacritics(c.name.toLowerCase())
    const phone = (c.phone ?? '').toLowerCase()
    const email = stripDiacritics((c.email ?? '').toLowerCase())
    return name.includes(trimmed) || phone.includes(trimmed) || email.includes(trimmed)
  })
}
